export default __webpack_public_path__ + "static/media/1832.88330bbe.png";